import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FacadeService} from "../shared/service-facade/facade.service";
import {ActivatedRoute} from "@angular/router";
import {BANKING_CENTER_ENTRY_PATH, BRANCH_ID} from "../shared/constants";
import {CoreService} from "../shared/services/core.service";
import {FormBuilder, Validators} from "@angular/forms";
import {MatOption} from "@angular/material/core";
import {MainLayoutService} from "../shared/services/main-layout.service";

@Component({
  selector: 'app-branch',
  templateUrl: './branch.component.html',
  styleUrls: ['./branch.component.scss'],
  encapsulation: ViewEncapsulation.None,
})


export class BranchComponent implements OnInit {
  branchList: BranchCategories[] = new Array();
  branchForm = this.formBuilder.group({
    branch: ['', Validators.required]
  });
  branchId: string = "";
  isSelected = false;

  constructor(
    private facadeService: FacadeService,
    private route: ActivatedRoute,
    private coreService: CoreService,
    private mainLayout: MainLayoutService,
    private formBuilder: FormBuilder) {
  }

  ngOnInit(): void {
    this.mainLayout.setPageTitle("Select a Branch")

    this.facadeService.clearLocalStorage();
    this.facadeService.getBranchList().subscribe(branchList => {
      branchList.forEach((branch: any) => {
        if (!this.isExistingCategory(branch.branchCity)) {
          const city = {
            name: branch.branchCity,
            branches: Array()
          }
          city.branches = city.branches.concat(
            branchList.filter((branch: any) => branch.branchCity === city.name)
          );
          this.branchList.push(city);
        }
      });
      this.coreService.isDataLoaded.next(true);
    });
  }

  isExistingCategory(name: string): boolean {
    return this.branchList
      .map(branch => branch.name)
      .includes(name);
  }

  onBranchSelectionClick(event: any) {
    if (this.branchId === "") {
      return
    }
    this.facadeService.addLocalStorageItem(BRANCH_ID, this.branchId);
    this.coreService.navigate(BANKING_CENTER_ENTRY_PATH);
  }

  onBranchSelectionChange(event: any) {
    let displayText = (event.source.selected as MatOption).value;
    this.branchId = displayText;
    this.isSelected = true;
  }

}

export interface BranchCategories {
  name: string,
  branches: any[];
}
